import { Link } from "react-router-dom";
import { ChevronRight, Gift } from "lucide-react";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { useAuth } from "@/context/AuthContext";

export const WhatsAppFeedButton = () => {
  const { user } = useAuth();
  return (
  <Link to="/gemeinsam-punkte-sammeln" state={{ from: "feed" }} data-testid="feed-whatsapp-button"
    className="wa-btn wa-glow group relative flex items-center gap-4 p-4 rounded-3xl text-white overflow-hidden">
    <span className="wa-sheen" aria-hidden />
    <span className="relative w-12 h-12 rounded-2xl bg-white/20 ring-1 ring-white/40 flex items-center justify-center shrink-0">
      <WhatsAppIcon className="w-7 h-7" />
      <span className="wa-gift absolute -top-2 -right-2 w-6 h-6 rounded-full bg-amber-300 text-amber-900 flex items-center justify-center shadow"><Gift className="w-3.5 h-3.5" /></span>
    </span>
    <span className="relative flex-1 min-w-0">
      <span className="block font-display text-lg font-extrabold leading-tight">Gemeinsam Punkte sammeln</span>
      <span className="block text-xs text-white/90 mt-0.5">Unsere WhatsApp-Gruppe – Tipps, Spiele & Hilfe</span>
      {user && !user.wa_bonus_at && <span className="mt-1.5 inline-flex items-center gap-1 px-2.5 h-6 rounded-full bg-gradient-to-r from-amber-200 to-amber-400 text-[11px] font-extrabold text-[#4a2a08] shadow-sm" data-testid="feed-whatsapp-bonus">+25 Punkte für den ersten Blick</span>}
    </span>
    <ChevronRight className="relative w-6 h-6 shrink-0 group-hover:translate-x-1 transition-transform" />
  </Link>
  );
};
